import { Localized } from "@fluent/react";
import { Alert, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, Stack, TextField } from "@mui/material"
import { useCallback, useState } from "react";
import { showError, showSuccess } from "../../notifications/notificationsSlice";
import { useAppDispatch } from "../../../app/hooks";
import { SaveButton } from "../../../app/components/SaveButton";
import { CancelButton } from "../../../app/components/CancelButton";
import { sendTestRelease } from "./ReleasesApi";
import { useNavigate } from "react-router-dom";

export interface SendTestReleaseDialogProps {
    id: string;
    onCancel: () => void
}

export const SendTestReleaseDialog: React.FC<SendTestReleaseDialogProps> = ({ id, onCancel }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch()
    const [saving, setSaving] = useState(false)
    const [serverError, setServerError] = useState("")
    const [email, setEmail] = useState<string>("");
    const [language, setLanguage] = useState<string>("");

    const handleEmailChange = useCallback(e => {
        setEmail(e.target.value)
    }, [])
    
    const handleLanguageChange = (e) => setLanguage(e.target.value);

    const handleSaveClick = async () => {
        setSaving(true)

        try {
            const result = await dispatch(sendTestRelease({ id, email, language }))
            if (sendTestRelease.fulfilled.match(result)) {
                dispatch(showSuccess("saved"))
            } else {
                let errorMsg = "error"
                if (result.payload && result.payload.kind === 'http') {
                    const problem = result.payload.problem
                    if (problem) {
                        errorMsg = problem.title

                    }
                }
                setServerError(errorMsg)
            }
        }
        catch (error) {
            dispatch(showError("error"));
        }
        finally {
            setSaving(false)
        }
    }

    return <>
        <Dialog open={true} maxWidth="md" fullWidth>
            <DialogTitle>
                <Localized id="releases-send-test-message">_Wyślij testową wiadomość</Localized>
            </DialogTitle>
            <DialogContent>
                <Stack direction="column" spacing={2} padding={2}>
                    <TextField 
                        required                            
                        value={email}
                        fullWidth
                        onChange={handleEmailChange}
                        label="Email" />

                    <FormControl fullWidth>
                        <InputLabel id="app-language-label"><Localized id="settings-lang">_Język</Localized></InputLabel>
                        <Select
                            labelId="app-language-label"
                            value={language}
                            onChange={handleLanguageChange}
                            label={<Localized id="settings-lang">_Język</Localized>}
                            fullWidth
                        >
                            <MenuItem value={'PL'}>Polski</MenuItem>
                            <MenuItem value={'EN'}>Angielski</MenuItem>
                            <MenuItem value={'BOTH'}>Obie wersje językowe</MenuItem>
                        </Select>
                    </FormControl>
                </Stack>
                {
                    serverError && <Alert sx={{ marginTop: 1, }} onClose={() => { setServerError("") }} severity="error">
                        <Localized id={serverError}>
                            <span>Server error</span>
                        </Localized>
                    </Alert>
                }
            </DialogContent>
            <DialogActions>
                <SaveButton onClick={handleSaveClick} loading={saving} />
                <CancelButton onClick={onCancel} loading={saving} />
            </DialogActions>
        </Dialog>
    </>
}

